import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M10 8h4l-4 8h4","key":"svg-0"}]]

const IconLetterZSmall = createReactComponent('outline', 'letter-z-small', 'LetterZSmall', __iconNode);

export default IconLetterZSmall;